<template>
  <div>
    <div v-if="activeBuyCredits === 'true'">
      <div class="header">
        <h3 class="title-content m-0">Comprar Créditos</h3>
      </div>
      <v-stepper v-model="level" vertical>
        <v-stepper-step color="#08437B" step="1">
          <span class="title-stepper">Selecionar Pagamento</span>
        </v-stepper-step>
        <v-stepper-content step="1">
          <method-payment-v2
              :transaction-type="1"
              :validPayment="validPayment"
              v-on:update:validated="createOrder($event)"
              @loading="loading = $event"
              :options="{
                            label:'VALOR DA COMPRA',
                        }"
          />
          <v-btn
              :loading="loading"
              class="btn-confirm float-right"
              text
              @click="validPayment = !validPayment"
          >Continuar
          </v-btn>
        </v-stepper-content>
        <v-stepper-step color="#08437B" step="2">
          <span class="title-stepper">Confirmar Compra</span>
        </v-stepper-step>
        <v-stepper-content step="2">
          <resume-buy :details="payment" :order="order"/>
          <div class="button-group">
            <v-btn
                :loading="loading"
                class="btn-cancel"
                @click.prevent="refreshPage()"
                text
            >Cancelar
            </v-btn>
            <v-btn
                :loading="loading"
                class="btn-confirm-outlined"
                @click.prevent="level = 1"
                text
            >
              <i class="fas fa-pen mr-1"></i> Corrigir
            </v-btn>
            <v-btn
                :loading="loading"
                class="btn-confirm"
                @click.prevent="preConfirm()"
                text
            >Finalizar Compra
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper>
      <pix-dialog :order="order"/>
      <debit-dialog :order="order"/>

      <v-snackbar
          v-model="message_success"
          :color="'success'"
          :multi-line="true"
          :right="true"
          :timeout="2000"
          :top="true"
          class="snackbar-success"
      >
        <span>
          <i class="fas fa-check mr-2"></i> Compra realizada com sucesso!
        </span>
      </v-snackbar>

      <v-dialog v-model="verificationError" persistent max-width="400">
        <v-card>
          <v-card-title>
            <i class="fas fa-window-close ml-auto icon-close-modal" @click.prevent="verificationError = false"></i>
          </v-card-title>
          <v-card-text>
            <verify-phone-form
                title="Atenção"
                :error-msg="errorBuy"
                @continue-action="cleanError"
            ></verify-phone-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="addressError" persistent max-width="400">
        <v-card>
          <v-card-title>
            <i class="fas fa-window-close ml-auto icon-close-modal" @click.prevent="addressError = false"></i>
          </v-card-title>
          <v-card-text>
            <profile
                :error-msg="errorBuy"
                :is-modal="true"
                @continue-action="cleanError"
            ></profile>
          </v-card-text>
        </v-card>
      </v-dialog>

      <generic-error-dialog
          @cleanError="cleanError"
          :error-text="errorBuy"
          :visible="genericError"
      />
    </div>
    <order ref="order"/>
  </div>
</template>

<script>
import MethodPaymentV2 from "../components/MethodPayment/MethodPaymentV2.vue";
import VerifyPhoneForm from "@/components/VerifyPhoneForm";
import ResumeBuy from "../components/ResumeBuy";
import Profile from "@/views/Profile";
import Order from "@/components/MethodPayment/Order.vue";
import GenericErrorDialog from "@/components/GenericErrorDialog.vue";
import DebitDialog from "@/components/MethodPayment/DebitDialog.vue";
import PixDialog from "@/components/MethodPayment/PixDialog.vue";

export default {
  name: "BuyCredit",
  components: {
    PixDialog,
    DebitDialog,
    GenericErrorDialog,
    Order,
    Profile,
    MethodPaymentV2,
    ResumeBuy,
    VerifyPhoneForm,
  },
  data: function () {
    return {
      loading: false,
      level: 1,
      order: null,
      payment: {},
      message_success: false,
      errorBuy: null,
      verificationError: false,
      addressError: false,
      genericError: false,
      validPayment: false,
    };
  },
  methods: {
    async createOrder(methodPayment) {
      try {
        this.payment.method_payment = methodPayment;

        this.payment.body = {
          quantity: this.getIntMoney(methodPayment.price),
          user_id: this.user_id,
        }

        this.loading = true;
        this.order = await this.$refs.order.createOrder(1, this.payment);
        this.level = 2;
      } catch (e) {
        this.handleCatchError(e)
      }
      this.loading = false;
    },
    async preConfirm() {
      try {
        this.loading = true;
        this.order = await this.$refs.order.preConfirmOrder();

        if (this.order.payment_form.id === 5) {
          window.open(this.order.collection_document.file);
          setTimeout(function () {
            location.reload();
          }, 2000);
          return;
        }

        if (this.order.payment_form.id === 2) {
          await this.$refs.order.confirmOrder();
          this.message_success = true;
          setTimeout(function () {
            location.reload();
          }, 1000);
          return;
        }
      } catch (e) {
        this.handleCatchError(e)
      }
      this.loading = false;
    },
    handleCatchError(error) {
      if (error.response.data.type === 'UserNotVerified') {
        this.errorBuy = this.getErrorMessage(error);
        this.verificationError = true;
      } else if (error.response.data.type === 'ValidationException') {
        this.errorBuy = this.getErrorMessage(error);
        this.addressError = true;
      } else {
        this.errorBuy = this.getErrorMessage(error);
        this.genericError = true;
      }
      this.level = 1;
    },
    cleanError() {
      this.verificationError = false;
      this.addressError = false;
      this.genericError = false;
      this.errorBuy = null;
    },
    handleVerifyPhoneDialog() {
      this.verificationError = false;
      this.errorBuy = null;
    },
    handleVerifyProfileDataDialog() {
      this.addressError = false;
      this.errorBuy = null;
    },
    refreshPage() {
      location.reload();
    }
  },
  computed: {
    user_id: function () {
      return JSON.parse(localStorage.getItem("user")).id;
    },
    activeBuyCredits() {
      return process.env.VUE_APP_BUY_CREDITS;
    },
  },
};
</script>

<style scoped>
.v-stepper__step--inactive .title-stepper {
  font-family: Roboto-Regular;
}

.v-stepper__step--active .title-stepper {
  color: #000 !important;
  font-family: Roboto-Bold;
  text-shadow: 0 0 0 0;
}

.warning-paragraph-modal {
  font-size: 16px;
  padding: 30px 20px 0 20px;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.qrcode .steps p {
  margin: unset;
}

.qrcode span {
  font-size: 16px;
  color: #3f3f3f;
  margin: unset;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  position: relative;
  z-index: 10;
}


.v-btn.v-btn--disabled,
.v-btn.v-btn--disabled.v-btn--has-bg,
button.v-btn.v-btn--disabled {
  opacity: 0.85 !important;
  color: #555555 !important;
}

.btn-confirm.v-btn.v-btn--disabled {
  background-color: rgba(0, 0, 0, 0.7) !important;
  color: rgba(255, 255, 255, 0.85) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
}

@media only screen and (max-width: 500px) {
  .theme--light.v-stepper {
    width: 90vw;
  }

  .v-stepper__content button {
    width: 100%;
    margin: 5px 0;
  }

  .btn-confirm,
  .btn-cancel {
    width: 100%;
    margin: 5px 0 !important;
    padding: 0;
  }
  .header {
    display: block;
    align-items: center;
    margin-bottom: 15px;
  }
  .v-stepper__content {
    overflow: visible !important;
    position: relative;
  }
  .v-stepper__wrapper {
    position: static !important;
    z-index: auto !important;
  }

  .button-group {
    flex-direction: column;
  }
}
</style>
